import { __rest as a } from "tslib";
import e from "classnames";
import * as r from "react";
import { classNameModifier as i } from "../shared/utils.js";
import { ComponentClassNames as s } from "../shared/constants.js";
import { View as t } from "../View/View.js";
const o = r.forwardRef((o, l) => {
  var {
      className: m,
      orientation: n = "horizontal",
      size: d,
      label: c
    } = o,
    f = a(o, ["className", "orientation", "size", "label"]);
  const p = e(s.Divider, i(s.Divider, n), i(s.Divider, d), c ? s.DividerLabel : null, m);
  return r.createElement(t, Object.assign({
    "aria-orientation": n,
    as: "hr",
    className: p,
    "data-size": d,
    "data-label": c,
    ref: l
  }, f));
});
o.displayName = "Divider";
export { o as Divider };